import $ from 'jquery';
import { debounce, getWindowWidth } from '../utils/functions';

const $window = $(window);
const animationDuration = 300;
const swipeTreshold = { x: 30, y: 30 };
const $carrouselEl = $('.carrousel');

$(function () {
    if ($carrouselEl.length > 0) {
        $carrouselEl.each(function () {
            const $thisEl = $(this);
            setTimeout(function () {
                carrousel($thisEl);
            }, 500);
        });
    }
});

function carrousel(carrouselEl) {
    const $prev = carrouselEl.find('.carrousel__arrow_prev');
    const $next = carrouselEl.find('.carrousel__arrow_next');
    const $indicatorDots = carrouselEl.find('.carrousel__indicator-dot');

    const data = {
        item: 0,
        itemWidth: -1,
        allItemsWidth: -1,
        offsetLeft: -1,
        offsetRight: -1,
        startMousePos: { x: -1, y: -1 },
        endMousePos: { x: -1, y: -1 },
    };

    init(carrouselEl, data);
    $window.on(
        'resize:width',
        debounce(function () {
            init(carrouselEl, data);
        })
    );

    $prev.on('click', function () {
        scrollLeft(carrouselEl, data);
    });
    $next.on('click', function () {
        scrollRight(carrouselEl, data);
    });
    $indicatorDots.on('click', function () {
        data.item = $(this).data('item');
        scrollToItem(carrouselEl, data, animationDuration, true, data.item * data.itemWidth, false);
    });

    carrouselEl.on('touchstart', function (event) {
        onTouchStart(carrouselEl, event, data);
    });
    carrouselEl.on('touchend', function (event) {
        onTouchEnd(carrouselEl, event, data);
    });
}

function init(element, data) {
    const $card = element.find('.carrousel__card');
    data.itemWidth = $card.outerWidth(true);

    const windowWidth = getWindowWidth();
    let padding = '';
    if (windowWidth < 2 * data.itemWidth) {
        padding = (windowWidth - $card.outerWidth()) / 2 + 'px';
    }
    const $cardContainer = element.find('.carrousel__card-container');
    $cardContainer.css({
        'padding-left': padding,
        'padding-right': padding,
    });

    getOffsets(element, data);
    scrollToItem(element, data, 0, false);
}

function indicator(element, data) {
    element.find('.carrousel__indicator-dot.active').removeClass('active');
    $(element.find('.carrousel__indicator-dot').get(data.item)).addClass('active');
}

function getOffsets(element, data) {
    const $cardContainer = element.find('.carrousel__card-container');
    data.offsetLeft = $cardContainer.offset().left;
    data.offsetRight = getWindowWidth() - data.offsetLeft - $cardContainer.outerWidth();
    const padding = {
        left: parseFloat($cardContainer.css('padding-left')),
        right: parseFloat($cardContainer.css('padding-right')),
    };
    data.allItemsWidth = $cardContainer.outerWidth() - padding.left;
}

function noOverflow(data) {
    return (parseInt(data.offsetRight) > 0 && parseInt(data.offsetLeft) > 0) || data.allItemsWidth < getWindowWidth();
}

function isScrolledLeft(data) {
    return Math.abs(parseInt(data.offsetLeft)) <= 0;
}

function isScrolledRight(data) {
    return Math.abs(parseInt(data.offsetRight)) <= 0;
}

function scrollLeft(element, data) {
    if (!isScrolledLeft(data)) {
        data.item--;
        scrollToItem(element, data, animationDuration, false);
    }
}

function scrollRight(element, data) {
    if (!isScrolledRight(data)) {
        data.item++;
        scrollToItem(element, data);
    }
}

function scrollToItem(element, data, duration = animationDuration, endstep = true, position = data.item * data.itemWidth, constantSpeed = true) {
    const $carrouselContainer = element.find('.carrousel__container');

    let speedMul = 1;
    if (constantSpeed === true) {
        const distance = Math.abs($carrouselContainer.scrollLeft() - position);
        if (distance != data.itemWidth) {
            speedMul = distance / data.itemWidth;
        }
    }

    $carrouselContainer.stop().animate({ scrollLeft: position }, duration * speedMul, 'linear', function () {
        getOffsets(element, data);
        if (endstep === true) {
            if (Math.abs(data.offsetRight) <= data.itemWidth / 2 && !isScrolledRight(data)) {
                scrollToItem(element, data, duration, false, position + Math.abs(data.offsetRight));
            }
        }

        if (noOverflow(data)) {
            element.addClass('carrousel-no-overflow');
        } else {
            element.removeClass('carrousel-no-overflow');

            if (isScrolledLeft(data)) {
                element.addClass('carrousel-is-left');
            } else {
                element.removeClass('carrousel-is-left');
            }

            if (isScrolledRight(data)) {
                element.addClass('carrousel-is-right');
            } else {
                element.removeClass('carrousel-is-right');
            }
        }

        indicator(element, data);
    });
}

function onTouchStart(element, event, data) {
    if (element.hasClass('carrousel-no-overflow')) return;

    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.startMousePos.x = touch.pageX;
    data.startMousePos.y = touch.pageY;
}

function onTouchEnd(element, event, data) {
    if (element.hasClass('carrousel-no-overflow')) return;

    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.endMousePos.x = touch.pageX;
    data.endMousePos.y = touch.pageY;

    const mousePosDiff = {
        x: data.startMousePos.x - data.endMousePos.x,
        y: data.startMousePos.y - data.endMousePos.y,
    };

    data.startMousePos = { x: -1, y: -1 };
    data.endMousePos = { x: -1, y: -1 };

    if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
        if (mousePosDiff.x > 0) {
            scrollRight(element, data);
        } else {
            scrollLeft(element, data);
        }
    }
}
